<template>
    <div class="pa-5">
        <confirm-dialog ref="confirmDialog"></confirm-dialog>
        <alert-dialog ref="incidentClosedDialog"></alert-dialog>
        <v-dialog :eager="true" v-model="sendMessageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <SendMessage ref="sendMessageDialog" @close="closeSendMesage" style="height:100%">
            </SendMessage>
        </v-dialog>
        <v-form ref="submitMessageForm" @submit.prevent="submitMessage">
            <div v-if="loading" style="text-align: center; margin-top:200px">
                <v-progress-circular
                        :width="3"
                        color="green"
                        indeterminate=""/>
            </div>
            <div v-if="!loading">
                <v-row v-for="message in mappedMessages" :justify="message.justify" :key="message.id">
                    <v-col cols="6">
                        <div class="d-flex justify-space-between">
                            <div class="creator-name">{{message.creatorName}}</div>
                            <div class="creator-date"><date-time-display v-bind:date="message.date"></date-time-display></div>
                        </div>

                        <div :class="message.classes">
                            {{message.message}}
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-footer app fixed inset>
                <v-container fluid>
                    <div class="d-flex justify-space-between">
                        <div class="text-wrap">
                            <pre><strong>{{incident.premiseName}}</strong> {{incident.trackingNumber}} {{incident.eventText}} - Created On <date-time-display v-bind:date="incident.dateTime"/> By {{incident.userName}} {{formatPhone()}}</pre>
                        </div>
                        <div>
                            <div v-if="isConnectError" class="red lighten-2 rounded-lg"><v-icon>mdi-alert</v-icon>Connection Error</div>
                            <v-progress-circular
                                    :width="3"
                                    :size="20"
                                    color="green"
                                    style="padding-bottom:2px;"
                                    v-if="pendingMessageCount > 0"
                                    indeterminate=""/>
                        </div>
                    </div>
                    <div v-if="cameraEnabled()">
                        <v-form :action="cameraUrl" method="POST" ref="cameraSubmitForm" target="_blank" enctype="application/x-www-form-urlencoded">
                            <a @click="openCameraApp()" href="javascript:void(0)">Access Cameras</a>
                            <input type="hidden" name="api_key" :value="cameraToken"/>
                        </v-form>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="11">
                            <v-text-field
                                    v-model="message"
                                    outlined
                                    label="Message"
                                    append-icon="mdi-send"
                                    @click:append="submitMessage()">
                                <template slot="prepend">
                                    <div class="d-inline-flex align-center justify-center" style="line-height:1;height:24px;">
                                        <v-btn outlined color="red" icon title="Open Camera Application" class="mr-2" v-if="cameraEnabled()" @click="openCameraApp()"><v-icon>mdi-cctv</v-icon></v-btn>
                                        <v-btn outlined color="blue" icon title="Send Announcement to Premises" v-if="$permissionHolder.hasPermission('FIRST_ALERT.ANNOUNCE')" @click="openSendMessage()"><v-icon>mdi-bullhorn</v-icon></v-btn>
                                     </div>
                                </template>
                                <v-progress-circular
                                        :width="3"
                                        v-show="overlay"
                                        color="red"
                                        indeterminate="">
                                </v-progress-circular>
                            </v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <close-incident :incident-id="incident.id" :is-cad-incident="isCadIncident()" @onClose="afterCloseIncident" color="warning" x-large class="ml-1">
                                Close
                            </close-incident>
                        </v-col>
                    </v-row>
                </v-container>
            </v-footer>
        </v-form>
    </div>
</template>


<script>

    import api from '@/api';
    import DateTimeDisplay from "@/components/common/DateTimeDisplay";
    import ConfirmDialog from "@/components/common/ConfirmDialog";
    import AlertDialog from "@/components/common/AlertDialog";
    import MessageQueue from "@/message-queue";
    import SendMessage from "@/components/premise/SendMessage";
    import CloseIncident from "../components/CloseIncident";

    export default {
        name: "IncidentCommunications",
        components : {CloseIncident, DateTimeDisplay,ConfirmDialog, AlertDialog, SendMessage},
        computed : {
            mappedMessages() {
                return this.messages.map((msg) => {
                    msg.justify = msg.creatorId == this.loggedInUserId ? 'end' : 'start';
                    msg.classes = msg.creatorId == this.loggedInUserId ? 'message-bubble left' : 'message-bubble right';
                    return msg;
                });
            }
        },
        data () {
            return {
                pendingMessageCount : 0,
                isConnectError : false,
                incident : {},
                webSocket : null,
                loggedInUserId : null,
                message : null,
                overlay : false,
                loading : true,
                messages : [],
                sendMessageDialog : false,
                cameraUrl : null,
                cameraToken :null
            }
        },
        mounted() {
            this.messageQueue = new MessageQueue(this.$route.params.cadRequestId,this.messagingCallback,this.closedCallback);
            this.loggedInUserId = this.$userHolder.getUserId();
            this.getData().then(()=> {
                this.loading = false;
                setTimeout(() => {
                    this.scrollToEnd();
                },0);
            },() => {
                alert("Error Loading Required Data");
            });

            this.subscription = this.$socket.subscribe("/queue/incident/"+this.$route.params.cadRequestId,(message) => {
                const m = JSON.parse(message.body);
                this.messages.push(m);
                setTimeout(() => {
                    this.scrollToEnd();
                },0);
            });
        },
        beforeDestroy() {
            if (this.subscription) {
                this.$socket.unsubscribe(this.subscription);
                this.subscription = null;
            }
            if (this.messageQueue) {
                this.messageQueue.clear();
            }
        },
        methods : {
            cameraEnabled() {
                return this.cameraUrl != null && this.cameraUrl !== '' && this.cameraToken && this.cameraToken !== ''
            },
            openCameraApp() {
                this.$refs.cameraSubmitForm.$el.submit();
            },
		    formatPhone() {
			if (this.incident.phoneNumber) {
				let ph = this.incident.phoneNumber.replaceAll(/[^\d]*/g,'');
				if (ph.length == 10) {
					return `(${ph.substring(0,3)}) ${ph.substring(3,6)} - ${ph.substring(6)}`
				}
				return ph;
			}

			return '';
		  },
            openSendMessage() {
                this.sendMessageDialog = true;
                this.$refs.sendMessageDialog.open(this.incident.premiseId);
            },
            closeSendMesage() {
                this.sendMessageDialog = false;
            },
            messagingCallback(length) {
                this.pendingMessageCount = length;
            },
            closedCallback() {
                this.$refs.incidentClosedDialog.open('Closed Incident','This Incident Has Been Closed.').then(() => {
                    this.$router.go(-1);
                })
            },
            scrollToEnd() {
                this.$vuetify.goTo(document.body.scrollHeight);
            },
            getData() {
                return new Promise((resolve,reject) => {
                    api.incident.communications.get(this.$route.params.cadRequestId).then((context) => {
                        this.incident = context.incident;
                        this.messages = context.messages;
                        this.cameraUrl = context.cameraUrl;
                        this.cameraToken = context.cameraKey;
                        resolve();
                    });
                });
            },
            afterCloseIncident() {
                this.$router.go(-1);
            },
            isCadIncident() {
                return this.incident.cadEventType && this.incident.cadEventType != '';
            },
            submitMessage() {
                const message = this.message;
                if (!message || message === '') {
                    return;
                }
                this.message = '';
                this.doSubmitMessage(0,message);
            },
            doSubmitMessage(retryCount,message) {
                let obj = {
                    narrative:message,
                };

                this.messageQueue.enqueue(obj)

            }
        }
    }
</script>

<style scoped>

    .message-bubble {
        padding: 10px;
        text-align: center;
        font-size:1em;
        font-family: arial;
        position:relative;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        text-align:left;
    }

    .message-bubble.left {
        background: #03628e;
        border:1px solid #9cfcfc;
        color: #fff;
    }

    .message-bubble.right {

        background: #058638;
        border:1px solid #9cfcfc;
        color: #fff;
    }

    .creator-name, .creator-date {
        color:black;
        padding:2px;
        font-size:10px;
    }
</style>